import el from "@cypherpotato/el";
import page from "page";
import { api } from "../../api";
import { Icon } from "../../components/icon";
import { ExternalLink } from "../../components/link";
import { LoginLayout } from "./login-layout";

const supportUrl = "https://aivax.net/contact/";

export default function (ctx) {
    const message = el.state.create({ type: null, text: "Checking your reset link..." });
    const token = ctx.query.token;
    const sentKey = token ? `aivax-login-reset:${token}` : "";

    return LoginLayout(
        el("div.login-form",
            {
                mount() {
                    if (!token) {
                        message.value = { type: "error", text: "This reset link is invalid or has expired." };
                        return;
                    }

                    if (sessionStorage.getItem(sentKey) === "sent") {
                        message.value = { type: "success", text: "Your new login key will be sent to your e-mail in a few moments." };
                        return;
                    }

                    api.postJson("/api/v1/auth/recovery/reset-key", { token }, { suppressError: true })
                        .then(result => {
                            if (result?.error) {
                                message.value = { type: "error", text: "This reset link is invalid or has expired." };
                                return;
                            }

                            sessionStorage.setItem(sentKey, "sent");
                            message.value = { type: "success", text: "Your new login key will be sent to your e-mail in a few moments." };
                        })
                        .catch(() => {
                            message.value = { type: "error", text: "This reset link is invalid or has expired." };
                        });
                }
            },
            el("header.login-form-header",
                el("h1", "Reset login key"),
                el("p", "A new login key is created when this link is valid. The previous key stops working.")
            ),
            el.state.listening([message], () =>
                el("div.login-form-message",
                    { classList: [message.value.type], "aria-live": "polite" },
                    message.value.type && Icon(message.value.type === "success" ? "check-line" : "error-warning-line"),
                    message.value.text
                )
            ),
            ExternalLink("Contact support", supportUrl, { rel: "noreferrer" }),
            el("div.login-register-row",
                el("a.app-link[href='/login']", "Back to sign in", {
                    onClick(event) {
                        event.preventDefault();
                        page("/login");
                    }
                })
            )
        )
    );
}
